import { useProject } from "@/context/ProjectContext";
import { ChatBox } from "@/components/ChatBox";
import { Card } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

export default function Chat() {
  const { selectedId, project } = useProject();
  const { t } = useTranslation();
  return (
    <div className="space-y-4" data-testid="chat-page">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight">{t("chatPage.title")}</h1>
        <p className="text-sm text-slate-500">
          {t("chatPage.subtitle", { project: project?.name || "the project" })}
        </p>
      </div>
      {selectedId ? (
        <Card className="overflow-hidden">
          <ChatBox projectId={selectedId} />
        </Card>
      ) : (
        <p className="text-sm text-slate-500" data-testid="chat-no-project">{t("chatPage.selectProject")}</p>
      )}
    </div>
  );
}
